import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  TemplateRef
} from '@angular/core';
import { Entity } from '@app/shared/models/models.interface';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BaseViewComponent } from '../base-view/base-view.component';

@Component({
  selector: 'vfs-card-view',
  templateUrl: './card-view.component.html',
  styleUrls: ['./card-view.component.scss']
})
export class CardViewComponent<T extends Entity, S = any>
  extends BaseViewComponent<T, S>
  implements OnInit, AfterViewInit {
  @Input() cardItemTemplate: TemplateRef<any>;

  /**
   * Initialize the component
   */
  ngOnInit() {}

  /**
   * After view
   */
  ngAfterViewInit() {
    merge(this.paginator.page)
      .pipe(tap(() => this.loadPage()))
      .subscribe();
  }

  /**
   * Get the card source
   */
  cardSource() {
    if (this.dataSource.getElements()) {
      return this.dataSource.getElements();
    } else {
      return null;
    }
  }
}
